import { Component, OnInit } from '@angular/core';
import { ModalService } from '@niceltd/sol/modal';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { SubscriptionSchedulerService } from 'src/app/reusables/subscription-scheduler/subscription-scheduler.service';
import { DeleteSubscriptionService, SubscriptionOptions } from './delete-subscription.service';

@Component({
    selector: 'cv-delete-subscription',
    templateUrl: './delete-subscription.component.html',
    styleUrls: ['./delete-subscription.component.scss']
})
export class DeleteSubscriptionComponent implements OnInit {
    private  modalData: SubscriptionOptions;
    public recipientEmails: string[] = [];
    public isDeleting = false;

    constructor(
        private readonly service: DeleteSubscriptionService,
        private readonly solModalService: ModalService,
        private readonly subscriptionService: SubscriptionSchedulerService,
        public cvLocalizationService: CVLocalizationService,
    ) { 
    }

    ngOnInit(): void {
        this.modalData = this.service._getModalData();
        this.initializeComponent();
    }

    private async initializeComponent(): Promise<void> {
        this.recipientEmails = await this.getEmailsRecipientsFromUUIDS();
        await this.cvLocalizationService.GetSection('Subscription_Modal');
    }

    async getEmailsRecipientsFromUUIDS () : Promise<string[]> {
        const recipientEmails = this.subscriptionService.getEmailsFromUUIDs(this.modalData.existingSchedule.RecipientEmails);
        return recipientEmails;
    }

    async approve() {
        try{
            this.isDeleting = true;
            await this.subscriptionService.deleteSubscriptionSchedule(this.modalData.subscriptionId, true);
            this.solModalService.close(true);
        }
        catch(error){
            console.error("Failed deleting subscription: ", error);
            this.solModalService.close(false);
        };
    }

    cancel() {
        if (!this.isDeleting)
            this.solModalService.close(false);
    }
}
